/**
 * Modules
 */

var isObject = require('@f/is-object')
var isArray = require('@f/is-array')
var forEachObj = require('@f/foreach-obj')
var forEachArr = require('@f/foreach-array')

/**
 * Expose foreach
 */

module.exports = forEach['default'] = forEach

/**
 * For each
 * @param  {Function} fn  iterator
 * @param  {Object}   obj object to iterate over
 */

function forEach (fn, a) {
  if (isArray(a)) return forEachArr.call(this, fn, a)
  if (isObject(a)) return forEachObj.call(this, fn, a)
}



//////////////////
// WEBPACK FOOTER
// ./~/@f/foreach/lib/index.js
// module id = ./node_modules/@f/foreach/lib/index.js
// module chunks = portal incabStudent incabManager incabTeacher incabHelpdesk marathons